import React from "react";

import {
  Box,
  Typography,
  Modal,
  Paper,
  useTheme,
  TextField,
  InputAdornment,
  Button,
  MenuItem,
  FormControlLabel,
  Switch,
  Grid,
  Stack,
  FormGroup,
} from "@mui/material";

import { Formik, Form } from "formik";
import { VerticalAlignCenter } from "@mui/icons-material";
import { AdminToggleActiveIcon, AdminToggleInActiveIcon } from "../../Svg";
import { convertToFormData } from "../../Services/Functions/global";

const style = {
  display: "flex",
  justifyContent: "center",
  flexDirection: "column",
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 380,
  height: "85vh",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  borderRadius: 1,
  verticalAlign: "middle",
};

const AdminFormModal = ({
  open,
  onClose,
  TextFieldArray,
  ButtonsArray,
  ToggleArray,
  TextFieldArrayIcon,
  MainHeading,
  initialFormData,
  ValidationSchemaModals,
  onSubmit,
}) => {
  const initialValues = TextFieldArray.reduce(
    (prevValue, row, index, arrayOfTextField) => {
      const obj = {
        [row?.name]: row?.value || (row?.value === false ? false : ""),
      };
      return { ...obj, ...(prevValue || {}) };
    },
    {}
  );

  const createFormData = (values) => {
    const data = TextFieldArray.reduce(
      (result, row, index, arrayOfTextField) => {
        const obj = { [row?.name]: values?.[row?.name] };
        result = result || {};

        if (row?.formKey) {
          result[row?.formKey] = {
            ...(result?.[row?.formKey] || {}),
            ...obj,
          };
          return result;
        } else {
          return { ...obj, ...(result || {}) };
        }
      },
      initialFormData
    );
    const formData = convertToFormData(data);
    onSubmit(formData);
  };

  // const LOGO_Name = values?.logo?.name.split(".")[0];
  // const LOGO_Extension = values?.logo?.name.split(".")[1];
  // const SHORT_Name = LOGO_Name.substring(0, 8);

  return (
    <>
      <Modal
        open={open}
        onClose={onClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Box width={300} margin={"auto"}>
            <Box display={"flex"} justifyContent={"center"}>
              <Typography paddingY={1} variant="h5" fontWeight={"600"}>
                {MainHeading}
              </Typography>
            </Box>
            <Formik
              initialValues={initialValues}
              validationSchema={ValidationSchemaModals}
              onSubmit={createFormData}
            >
              {({
                values,
                errors,
                touched,
                handleChange,
                handleSubmit,
                setFieldTouched,
                setFieldValue,
                setFieldError,
              }) => (
                <Form
                //   onSubmit={handleSubmit}
                >
                  <Box>
                    {TextFieldArray?.map((row, index) => {
                      return row?.type === "switch" ? (
                        <FormGroup>
                          <FormControlLabel
                            label={row?.label}
                            control={
                              <Switch
                                name={row?.name}
                                label={row?.label}
                                checked={values[row?.name]}
                                style={{ width: "auto" }}
                                color={row?.color || "success"}
                                onChange={(e) => {
                                  setFieldValue(
                                    row?.name,
                                    e.target.checked,
                                    true
                                  );
                                }}
                              />
                            }
                          />
                        </FormGroup>
                      ) : row?.type === "file" ? (
                        <Box>
                          <Button
                            variant="contained"
                            component="label"
                            style={row?.style}
                          >
                            {row?.text}
                            <input
                              accept={"image/*"}
                              name={row?.name}
                              type={row?.type}
                              value={row?.value}
                              onChange={(e) => {
                                const file = e.target.files[0];
                                setFieldValue("logo", file);
                                if (file.size > 5 * 1024 * 1024) {
                                  //   setAlertOpen(true);
                                  //   setAlertMsg("File size is greater than 5MB!");
                                  //   setAlertIcon("warning");
                                  //   setFieldError(
                                  //     "logo",
                                  //     "File size is greater than 5MB!"
                                  //   );
                                  //   setFieldValue("logo", "");
                                  //   setMinistryLogoUrl("");
                                  //   e.target.value = "";
                                  // } else {
                                  //   setMinistryLogoUrl(URL.createObjectURL(file));
                                }
                              }}
                              hidden
                            />
                          </Button>
                          <Box>
                            <Typography variant="caption">
                              {values?.logo?.name}
                            </Typography>{" "}
                          </Box>
                        </Box>
                      ) : (
                        <TextField
                          display={"flex"}
                          justifyContent={"center"}
                          fullWidth
                          key={`${row?.name}-${index}`}
                          label={row?.label}
                          name={row?.name}
                          value={values?.[row?.name]}
                          variant="standard"
                          onChange={handleChange}
                          size="small"
                          select={row?.type === "select"}
                          disabled={row?.disable}
                          // error={touched?.[row?.name] && Boolean(errors?.[row?.name])}
                          // helperText={touched?.[row?.name] && errors?.[row?.name]}
                          sx={row?.style}
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <Box sx={row?.style1}>
                                  <Box
                                    display={"flex"}
                                    flexDirection={"column"}
                                    justifyContent={"center"}
                                  >
                                    {row?.icon}
                                  </Box>
                                </Box>
                              </InputAdornment>
                            ),
                          }}
                        >
                          {row?.options?.map((option) => (
                            <MenuItem value={option?.value}>
                              {option?.name}
                            </MenuItem>
                          ))}
                        </TextField>
                      );
                    })}
                  </Box>
                  <Box
                    display={"flex"}
                    flexDirection={"column"}
                    justifyContent={"space-around"}
                    gap={2}
                    mt={3}
                  >
                    {ButtonsArray?.map((row, index) => {
                      return (
                        <Button
                          type={row?.type}
                          variant="contained"
                          sx={row?.style}
                        >
                          {row?.text}
                        </Button>
                      );
                    })}
                  </Box>
                </Form>
              )}
            </Formik>
          </Box>
        </Box>
      </Modal>
    </>
  );
};

export default AdminFormModal;
